__turbopack_context__.v({
  "chevron": "MobileBiomarkerTable-module__8qBP5W__chevron",
  "chip": "MobileBiomarkerTable-module__8qBP5W__chip",
  "chipsWrap": "MobileBiomarkerTable-module__8qBP5W__chipsWrap",
  "count": "MobileBiomarkerTable-module__8qBP5W__count",
  "disclaimer": "MobileBiomarkerTable-module__8qBP5W__disclaimer",
  "dot": "MobileBiomarkerTable-module__8qBP5W__dot",
  "expandContent": "MobileBiomarkerTable-module__8qBP5W__expandContent",
  "expandRow": "MobileBiomarkerTable-module__8qBP5W__expandRow",
  "expanded": "MobileBiomarkerTable-module__8qBP5W__expanded",
  "inactive": "MobileBiomarkerTable-module__8qBP5W__inactive",
  "open": "MobileBiomarkerTable-module__8qBP5W__open",
  "rowHeader": "MobileBiomarkerTable-module__8qBP5W__rowHeader",
  "rowLabel": "MobileBiomarkerTable-module__8qBP5W__rowLabel",
  "slideDown": "MobileBiomarkerTable-module__8qBP5W__slideDown",
  "summary": "MobileBiomarkerTable-module__8qBP5W__summary",
  "thumb": "MobileBiomarkerTable-module__8qBP5W__thumb",
  "wrapper": "MobileBiomarkerTable-module__8qBP5W__wrapper",
});
